

import React from 'react'
import '../index.css'
import Logo from '../assets/logo.png'
import { Link } from 'react-router-dom'

const DashboardFooter = () => {
  return (
    <div className="footer">
    <div className="first-footer">
        <img className="logo" src={Logo} alt="" />
    </div>
    <p>Copyright PropTera All Right Reserved.</p>
  </div>
  )
}

export default DashboardFooter